"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrintInstruction = exports.printInstructionDiscriminator = exports.PrintStruct = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const PrintArgs_1 = require("../types/PrintArgs");
exports.PrintStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['printArgs', PrintArgs_1.printArgsBeet],
], 'PrintInstructionArgs');
exports.printInstructionDiscriminator = 55;
function createPrintInstruction(accounts, args, programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
    var _a, _b;
    const [data] = exports.PrintStruct.serialize({
        instructionDiscriminator: exports.printInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.editionMetadata,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.edition,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.editionMint,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.editionTokenAccountOwner,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.editionTokenAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.editionMintAuthority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: (_a = accounts.editionTokenRecord) !== null && _a !== void 0 ? _a : programId,
            isWritable: accounts.editionTokenRecord != null,
            isSigner: false,
        },
        {
            pubkey: accounts.masterEdition,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.editionMarkerPda,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.payer,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: accounts.masterTokenAccountOwner,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.masterTokenAccount,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.masterMetadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.updateAuthority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.splTokenProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.splAtaProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.sysvarInstructions,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_b = accounts.systemProgram) !== null && _b !== void 0 ? _b : web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createPrintInstruction = createPrintInstruction;
//# sourceMappingURL=Print.js.map